import { create } from "zustand";

export type PanelView = "intelligence" | "transactions" | "settings";

export type PanelFocus =
  | { kind: "portfolio" }
  | { kind: "merchant"; merchantId: string }
  | { kind: "ethoca" }
  | { kind: "tc40" }
  | { kind: "cohort"; filter?: string }
  | { kind: "retention" }
  | { kind: "intel-graph" };

interface PanelState {
  view: PanelView;
  focus: PanelFocus;
  setView: (view: PanelView) => void;
  setFocus: (focus: PanelFocus) => void;
  reveal: (view: PanelView, focus: PanelFocus) => void;
}

export const usePanelStore = create<PanelState>((set) => ({
  view: "intelligence",
  focus: { kind: "portfolio" },
  setView: (view) => set({ view }),
  setFocus: (focus) => set({ focus }),
  reveal: (view, focus) => set({ view, focus }),
}));
